import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { RespuestaHistorialDto } from '../dto/integrador/respuesta-historial.dto';
import { RespuestaFechaCorteDto as RespuestaFechaCorteDto } from '../dto/integrador/respuesta-fecha-corte.dto';

@Injectable({
  providedIn: 'root',
})
export class HistorialService {
  // Define el endpoint de la API a consumir
  private apiUrl = `${environment.intApiUrl}/api`;

  // Constructor de la clase
  // Parámetros:
  // http: HttpClient - Cliente HTTP de Angular
  constructor(private http: HttpClient) {}

  // Obtiene el historial de expedientes
  // Parámetros:
  // id_entidad: number - Identificador de la entidad
  // Retorna un Observable de tipo RespuestaHistorialDto
  getHistorial(id_entidad: number): Observable<RespuestaHistorialDto> {
    return this.http.post<RespuestaHistorialDto>(
      `${this.apiUrl}/cm-historial`,
      {
        id_entidad: id_entidad,
      }
    );
  }

  // Obtiene la fecha de corte
  // Retorna un Observable de tipo RespuestaFechaCorteDto
  getFechaCorte(): Observable<RespuestaFechaCorteDto> {
    return this.http.get<RespuestaFechaCorteDto>(
      `${this.apiUrl}/cm-fecha-corte`
    );
  }
}
